function applyGridStyling() {
  const hitsList = document.querySelector(".ais-Hits-list");

  if (!hitsList) return;

  // hitsList.querySelectorAll(".ais-Hits-item").forEach((item) => {
  //   if (!item.textContent.trim()) {
  //     item.remove();
  //   }
  // });

  // if (hitsList.children.length === 0) {
  //   hitsList.remove();
  //   return; // stop further processing
  // }

  if (!hitsList.classList.contains("grid")) {
    hitsList.classList.add(
      "grid",
      "product-grid",
      "grid--2-col-tablet-down",
      "grid--4-col-desktop",
      "grid-view"
    );
  }

  hitsList.querySelectorAll(".ais-Hits-item").forEach((item) => {
    if (!item.classList.contains("grid__item")) {
      item.classList.add("grid__item");
    }
  });
}

document.querySelectorAll('.button-listgrid span').forEach(span => {
  span.addEventListener('click', () => {
    const view = span.dataset.view; // "grid" or "list"
    const hitsList = document.querySelector('.ais-Hits-list');

    if (!hitsList) return;

    // Remove both classes first
    hitsList.classList.remove('grid-view', 'list-view');

    // Add the selected view class
    hitsList.classList.add(`${view}-view`);

    // Optional: mark the active button
    document.querySelectorAll('.button-listgrid span').forEach(s => s.classList.remove('active'));
    span.classList.add('active');
  });
});

document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".openfilters, .panel-btn");
  if (trigger) {
    e.preventDefault();

    const facetsButton = document.querySelector(".ais-facets-button");
    if (facetsButton) facetsButton.click();

    document.body.classList.toggle("filters-open");
  }
});

document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".opensorting, .close-sort, .sort-button");
  if (trigger) {
    e.preventDefault();
    document.body.classList.toggle("filter-sort-open");
  }
});



document.addEventListener("DOMContentLoaded", () => {
  // Apply every 500ms, up to 10s max
  let attempts = 0;
  const maxAttempts = 20;
  const interval = setInterval(() => {
    applyGridStyling();
    attempts++;
    if (attempts > maxAttempts) clearInterval(interval);
  }, 500);

  // Observer as backup
  const target = document.body;
  const observer = new MutationObserver(applyGridStyling);
  observer.observe(target, {
    childList: true,
    subtree: true,
  });   
});




  // Function to load multiple script files
  function loadCustomScripts(scripts) {
    scripts.forEach(src => {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      document.head.appendChild(script);
    });
  }

  // Function to check if Algolia block is loaded
  function isAlgoliaLoaded() {
    return document.querySelector('#algolia-shopify-instantsearch') !== null;
  }

  // Set up MutationObserver
  const observeralgolia = new MutationObserver((mutations, obs) => {
    if (isAlgoliaLoaded()) {

      // Load multiple scripts here
      loadCustomScripts([
        '//royal-pharmacy-dev.myshopify.com/cdn/shop/t/11/assets/product-form.js?v=167674148376919780461753961926',
        '//royal-pharmacy-dev.myshopify.com/cdn/shop/t/11/assets/quick-add.js?v=73073840428863680991753961929'       
      ]);

      obs.disconnect(); // Stop observing
    }
  });

  // Start observing the body for changes
  observeralgolia.observe(document.body, {
    childList: true,
    subtree: true
  });


// cart drawer

// document.addEventListener('click', function (e) {
//   const button = e.target.closest('.custom-add-to-cart-algolia');
//   if (!button) return;

//   e.preventDefault();
//   e.stopPropagation();

//   const form = button.closest('form');
//   if (!form) return;

//   const formData = new FormData(form);
//   const serializedData = new URLSearchParams(formData).toString();

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//     body: serializedData
//   })
//     .then(res => res.json())
//     .then(data => {
//       const sectionsToFetch = ['cart-drawer', 'cart-icon-bubble','cart-count-mobile'];
//       const localePrefix = window.location.pathname.startsWith('/ar') ? '/ar' : '';
//       const url = `${localePrefix}/cart?sections=${sectionsToFetch.join(',')}&timestamp=${Date.now()}`;

//       // fetch sections
//       Promise.all([
//         fetch(url).then(r => r.json()),
//         fetch('/cart.js').then(r => r.json()) 
//       ]).then(([response, cartData]) => {
//         const cartDrawer = document.querySelector('cart-drawer');
//         if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
//           const sections = {
//             'cart-drawer': response['cart-drawer'],
//             'cart-icon-bubble': response['cart-icon-bubble'],
//             'cart-count-mobile': response['cart-count-mobile']
//           };

//           cartDrawer.renderContents({
//             id: data.id,
//             sections,
//             item_count: cartData.item_count 
//           });

//           cartDrawer.classList.remove('is-empty');
//         }
//       });
//     })
//     .catch(error => console.error('Add to cart failed:', error));
// });

//cart notification

// document.addEventListener('click', function (e) {
//   const button = e.target.closest('.custom-add-to-cart-algolia');
//   if (!button) return;

//   e.preventDefault();
//   e.stopPropagation();

//   const form = button.closest('form');
//   if (!form) return;

//   const formData = new FormData(form);
//   const serializedData = new URLSearchParams(formData).toString();

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//     body: serializedData
//   })
//     .then(res => res.json())
//     .then(data => {
//       const sectionsToFetch = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
//       const localePrefix = window.location.pathname.startsWith('/ar') ? '/ar' : '';
//       const url = `${localePrefix}/cart?sections=${sectionsToFetch.join(',')}&timestamp=${Date.now()}`;

//       // fetch updated sections
//       Promise.all([
//         fetch(url).then(r => r.json()),
//         fetch('/cart.js').then(r => r.json())
//       ]).then(([response, cartData]) => {
//         const cartNotification = document.querySelector('cart-notification');
//         if (cartNotification && typeof cartNotification.renderContents === 'function') {
//           const sections = {
//             'cart-notification-product': response['cart-notification-product'],
//             'cart-notification-button': response['cart-notification-button'],
//             'cart-icon-bubble': response['cart-icon-bubble']
//           };

//        cartNotification.renderContents({
//           key: data.key,  
//           sections,
//           item_count: cartData.item_count
//         });


//           cartNotification.classList.add('active');
//         }
//       });
//     })
//     .catch(error => console.error('Add to cart failed:', error));
// });
document.addEventListener('click', function (e) {
  const button = e.target.closest('.custom-add-to-cart-algolia');
  if (!button) return;

  e.preventDefault();
  e.stopPropagation();

  const form = button.closest('form');
  if (!form) return;

  const variantId = form.querySelector('[name="id"]').value; // Shopify variant ID
  const productCard = document.querySelector(
    `.card-wrapper.product-card-wrapper.custom-product-card-inner[data-variant-id="${variantId}"]`
  );

  if (!productCard) return;

  const backendQuantity = parseInt(productCard.getAttribute('data-variant-quantity')) || Infinity;
  const maxGlobalQuantity = window.maxProductQuantity || 5;

  // First fetch the cart to check existing quantity
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartItem = cart.items.find(item => String(item.variant_id) === String(variantId));
      const currentQty = cartItem ? cartItem.quantity : 0;

      // ✅ 1. Global Max Quantity Check
      if (currentQty + 1 > maxGlobalQuantity) {
        alert(`You can only add ${maxGlobalQuantity} items of this product`);
        return;
      }

      // ✅ 2. Backend Stock Quantity Check
      if (currentQty + 1 > backendQuantity) {
        alert(`You can only add ${backendQuantity} items of this product due to availability`);
        return;
      }

      // If passes both checks → proceed to add to cart
      const formData = new FormData(form);
      const serializedData = new URLSearchParams(formData).toString();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: serializedData
      })
        .then(res => res.json())
        .then(data => {
          const sectionsToFetch = [
            'cart-notification-product',
            'cart-notification-button',
            'cart-icon-bubble'
          ];
          const localePrefix = window.location.pathname.startsWith('/ar') ? '/ar' : '';
          const url = `${localePrefix}/cart?sections=${sectionsToFetch.join(',')}&timestamp=${Date.now()}`;

          Promise.all([
            fetch(url).then(r => r.json()),
            fetch('/cart.js').then(r => r.json())
          ]).then(([response, cartData]) => {
            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification && typeof cartNotification.renderContents === 'function') {
              const sections = {
                'cart-notification-product': response['cart-notification-product'],
                'cart-notification-button': response['cart-notification-button'],
                'cart-icon-bubble': response['cart-icon-bubble']
              };

              cartNotification.renderContents({
                key: data.key,
                sections,
                item_count: cartData.item_count
              });

              cartNotification.classList.add('active');
            }
          });
        })
        .catch(error => console.error('Add to cart failed:', error));
    });
});

